var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWindowBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#D9E5F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4336_53347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.803 12C22.4451 12.6181 22.2012 13.2956 22.083 14H11V26H29V20.917C29.7044 20.7988 30.3819 20.5549 31 20.197V27C31 27.553 30.56 28.001 29.998 28.001H10.002C9.87043 28.0013 9.74009 27.9756 9.61847 27.9254C9.49685 27.8752 9.38633 27.8015 9.29325 27.7085C9.20016 27.6155 9.12635 27.505 9.07602 27.3835C9.0257 27.2619 8.99987 27.1316 9 27V13C9 12.448 9.44 12 10.002 12H22.802H22.803ZM28 17C28.5304 17 29.0391 16.7893 29.4142 16.4142C29.7893 16.0391 30 15.5304 30 15C30 14.4696 29.7893 13.9609 29.4142 13.5858C29.0391 13.2107 28.5304 13 28 13C27.4696 13 26.9609 13.2107 26.5858 13.5858C26.2107 13.9609 26 14.4696 26 15C26 15.5304 26.2107 16.0391 26.5858 16.4142C26.9609 16.7893 27.4696 17 28 17ZM28 19C26.9391 19 25.9217 18.5786 25.1716 17.8284C24.4214 17.0783 24 16.0609 24 15C24 13.9391 24.4214 12.9217 25.1716 12.1716C25.9217 11.4214 26.9391 11 28 11C29.0609 11 30.0783 11.4214 30.8284 12.1716C31.5786 12.9217 32 13.9391 32 15C32 16.0609 31.5786 17.0783 30.8284 17.8284C30.0783 18.5786 29.0609 19 28 19ZM26 21H28V24H26V21Z",
    fill: "#3F7CDB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4336_53347"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowBlue);
export default __webpack_public_path__ + "static/media/window_blue.2c8d2f0d9a8d196ad62703510f819d88.svg";
export { ForwardRef as ReactComponent };